/* global google */
// eslint-disable-next-line spaced-comment
/// <reference types="google.maps" />
import { Injectable } from '@angular/core';
import { BehaviorSubject, bindCallback, Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import find from 'lodash-es/find';
import get from 'lodash-es/get';
import includes from 'lodash-es/includes';
import isEmpty from 'lodash-es/isEmpty';

export interface Geocode {
  address?: string;
  bounds?: {
    east?: number;
    north?: number;
    south?: number;
    west?: number;
  };
  location?: {
    coordinates: any[];
    type: 'Point';
  };
}

@Injectable()
export class GeocodeService {
  getLocationFromGeocode(location: string): Observable<Geocode | undefined> {
    const geolocationResults = new BehaviorSubject({});
    if ('undefined' === typeof google) {
      return of({});
    }
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: location }, (results, status) => {
      geolocationResults.next({
        ...results,
        status: google.maps.GeocoderStatus.OK,
      });
    });
    return geolocationResults.pipe(
      filter((geocodeResults) => !isEmpty(geocodeResults)),
      take(1),
      map((results: any): Geocode | undefined => {
        if (google.maps.GeocoderStatus.OK !== results.status) {
          return;
        }
        const geometry = get(results, ['0', 'geometry']);
        if (!geometry) {
          return;
        }
        return {
          address: get(results, ['0', 'formatted_address']),
          bounds: geometry.bounds,
          location: {
            coordinates: [geometry.location.lng(), geometry.location.lat()],
            type: 'Point',
          },
        };
      }),
    );
  }

  getCustomLabelFromCoordinates(lat: number, lng: number): string | undefined {
    if ('undefined' === typeof google) {
      return;
    }
    const geocoder = new google.maps.Geocoder();
    const latLng = new google.maps.LatLng(lat, lng);
    const geocodeFnc: any = bindCallback(geocoder.geocode);
    return geocodeFnc({ location: latLng }).pipe(
      take(1),
      map((response: any) => {
        const status = get(response, '1');
        if (status !== google.maps.GeocoderStatus.OK) {
          return;
        }
        const resultWithNeighborhood = find(get(response, [0]), (address) =>
          includes(address.types, 'neighborhood'),
        );
        const fallbackCustomLabel = get(response, '[0][1].formatted_address');
        return get(
          resultWithNeighborhood,
          'formatted_address',
          fallbackCustomLabel,
        );
      }),
    );
  }
}
